export default {
  api: {
    login: {
      method: "post",
      url: "/login",
      dataType: "formdata"
    },
    getUserInfo: {
      method: "get",
      url: "/user/info"
    },
    getInviteCode: {
      method: "get",
      url: "/user/getInviteCode"
    },
    logout: {
      method: "get",
      url: "/logout"
    },
    //实名认证
    realName: {
      method: "post",
      url: "/user/realName/submit"
    },
    address: {
      method: "get",
      url: "/user/address/list"
    },
    addAddress: {
      method: "post",
      url: "/user/address"
    },
    updataPhone: {
      url: "/user/updatePhoneNum",
      method: "put"
    }
  }
};
